import { render, staticRenderFns } from "./mr_hcx_report.vue?vue&type=template&id=0fa8ce96&scoped=true"
import script from "./mr_hcx_report.vue?vue&type=script&lang=js"
export * from "./mr_hcx_report.vue?vue&type=script&lang=js"
import style0 from "./mr_hcx_report.vue?vue&type=style&index=0&id=0fa8ce96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa8ce96",
  null
  
)

export default component.exports